import { CircularProgress, Dialog, DialogContent } from "@mui/material";

import Suspense from "@/components/molecules/Suspense";
import PaymentForm from "@/components/templates/PaymentForm";
import { AccountBalance, PaymentPayload } from "@/interfaces/talk2pay.iterfaces";
import { PaymentFormMessages } from "@/messages/platforms/talk2PayHome/payment-form.messages";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (formData: PaymentPayload) => void;
  messages: PaymentFormMessages;
  isLoadingTransfer: boolean;
  balanceData: AccountBalance | null;
}

const PaymentDialog = ({
  isOpen,
  onClose,
  onSubmit,
  messages,
  isLoadingTransfer,
  balanceData,
}: Props) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="md">
      <DialogContent>
        <Suspense isSuspended={isLoadingTransfer} fallback={<CircularProgress />}>
          <PaymentForm
            onSubmit={onSubmit}
            onCancel={onClose}
            messages={messages}
            balance={balanceData}
          />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
};

export default PaymentDialog;
